import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { smartDocParamType_Dynamic, smartDocParamType_EHR, smartDocParamType_External, smartDocParamType_Static, smartDocParamTypeLabelMap } from '@app/advisor-content-shared';
import './Editor_SmartDocParam.scss';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { Editor_SmartDocParam_Dynamic } from './Editor_SmartDocParam_Dynamic.js';
import { Editor_SmartDocParam_External } from './Editor_SmartDocParam_External.js';
import { Editor_SmartDocParam_EHR } from './Editor_SmartDocParam_EHR.js';
import { DropDown_SmartDocParamType } from '../DropDown_SmartDocParamType.js';
import { Editor_SmartDocParam_Static } from './Editor_SmartDocParam_Static.js';
const viewMode_View = 'view';
const viewMode_Edit = 'edit';
export class Editor_SmartDocParam extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.editMode = nextProps.editMode;
        state.params = nextProps.params ?? [];
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? viewMode_Edit : viewMode_View;
    // ######################## Render ########################
    render() {
        const className = _className('editor__smart-doc-param', this.state.editable.item.type);
        return _jsxs(LL_V_L, { className: className, children: [this.render_ParamTypeSelector(), this.render_ParamContent()] });
    }
    render_ParamTypeSelector = () => {
        const param = this.state.editable;
        const alwaysView = param.item.type === smartDocParamType_External || this.props.allowedParamTypes.length === 1;
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsxs("div", { className: 'editor__smart-doc-param__header', children: ["Param with key ", _jsx("b", { children: param.item.key }), " is of type"] }), _jsx(Component_SwitchView, { mode: alwaysView ? viewMode_View : this.getViewMode(), modes: [
                        {
                            key: viewMode_View,
                            renderer: () => _jsx("div", { className: 'editor__smart-doc-param__header', children: _jsx("b", { children: param.item.type ? smartDocParamTypeLabelMap[param.item.type] : 'N/A' }) })
                        },
                        { key: viewMode_Edit, renderer: () => _jsx(DropDown_SmartDocParamType, { editable: param, allowedParamTypes: this.props.allowedParamTypes }) }
                    ] })] });
    };
    render_ParamContent = () => {
        const param = this.state.editable;
        switch (param.item.type) {
            case smartDocParamType_Static:
                return _jsx(Editor_SmartDocParam_Static, { editable: param, editMode: this.state.editMode, params: this.state.params, filterLogTemplateId: this.props.filterLogTemplateId, allowedParamSubTypes: this.props.allowedParamSubTypes });
            case smartDocParamType_Dynamic:
                return _jsx(Editor_SmartDocParam_Dynamic, { editable: param, editMode: this.state.editMode, params: this.state.params, createNewExternalParam: this.props.createNewExternalParam });
            case smartDocParamType_External:
                return _jsx(Editor_SmartDocParam_External, { editable: param, editMode: this.state.editMode, params: this.state.params, allowedParamSubTypes: this.props.allowedParamSubTypes });
            case smartDocParamType_EHR:
                return _jsx(Editor_SmartDocParam_EHR, { editable: param, editMode: this.state.editMode });
            default:
                return _jsx(_Fragment, {});
        }
    };
}
//# sourceMappingURL=Editor_SmartDocParam.js.map